var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPointerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.625,
    height: 35.901,
    viewBox: "0 0 26.625 35.901",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_294",
    x: 0,
    y: 0,
    width: 26.625,
    height: 35.901,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4eb2d8",
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_295",
    x: 2.195,
    y: 2.188,
    width: 22.249,
    height: 25.75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4eb2d8",
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_296",
    x: 15.53,
    y: 9.49,
    width: 10.869,
    height: 14.371,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4eb2d8",
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_198",
    "data-name": "Groupe 198",
    transform: "translate(5.002 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5, -0.5)",
    filter: "url(#Trac\\xE9_294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_294-2",
    "data-name": "Trac\\xE9 294",
    d: "M977.734-284.547c.444.073.894.124,1.333.222A8.3,8.3,0,0,1,985.443-277c.009.109.023.218.029.327.015.306-.14.509-.4.527-.278.02-.456-.156-.475-.475a7.23,7.23,0,0,0-.957-3.284,7.183,7.183,0,0,0-5.788-3.727,7.381,7.381,0,0,0-7.881,5.509,6.665,6.665,0,0,0,.213,4.141,23.317,23.317,0,0,0,2.3,4.477,56.857,56.857,0,0,0,4.588,6.145c.023.028.04.06.076.114.126-.145.231-.263.331-.383a50.743,50.743,0,0,0,5.249-7.358c.356-.626.66-1.281.986-1.923a.444.444,0,0,1,.523-.289.438.438,0,0,1,.264.664c-.372.742-.73,1.492-1.144,2.21a51.311,51.311,0,0,1-4.954,6.954l-.287.346h.24q1.148,0,2.3,0c.337,0,.535.168.531.444s-.2.43-.523.43h-7c-.318,0-.52-.17-.524-.432s.2-.442.535-.443h2.53c-.244-.3-.46-.558-.673-.822a48.456,48.456,0,0,1-4.952-7.166,15.028,15.028,0,0,1-1.542-3.769,7.386,7.386,0,0,1,.682-5.135,8.175,8.175,0,0,1,6.14-4.533c.242-.044.488-.068.732-.1Z",
    transform: "translate(-963.85 285.05)",
    fill: "none",
    stroke: "#4eb2d8",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5, -0.5)",
    filter: "url(#Trac\\xE9_295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_295-2",
    "data-name": "Trac\\xE9 295",
    d: "M1005.2-254.383a6.125,6.125,0,0,1-6.112,6.13,6.132,6.132,0,0,1-6.137-6.131,6.131,6.131,0,0,1,6.127-6.119A6.124,6.124,0,0,1,1005.2-254.383Zm-.875.013a5.248,5.248,0,0,0-5.229-5.258,5.255,5.255,0,0,0-5.27,5.242,5.256,5.256,0,0,0,5.254,5.258A5.25,5.25,0,0,0,1004.324-254.37Z",
    transform: "translate(-985.76 263.19)",
    fill: "none",
    stroke: "#4eb2d8",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5, -0.5)",
    filter: "url(#Trac\\xE9_296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_296-2",
    "data-name": "Trac\\xE9 296",
    d: "M1139.5-179.822a.423.423,0,0,1,.429-.429.438.438,0,0,1,.44.424.451.451,0,0,1-.446.446A.438.438,0,0,1,1139.5-179.822Z",
    transform: "translate(-1118.97 190.24)",
    fill: "none",
    stroke: "#4eb2d8",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerIcon);
export default __webpack_public_path__ + "static/media/pointer-icon.9039315a8b47042c3d8012e228e6a542.svg";
export { ForwardRef as ReactComponent };